import React from 'react'
import { Helmet } from 'react-helmet'
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader'
import Ops1 from '../../../Componet/Operations/Ops1He'
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm'

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer'

function OperationsHePage() {
    return (
        <div className="operations-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - דבאופס (DevOps)</title>
                <meta
                    name="description"
                    content="שירותי DevOps, תשתיות וענן לעסקים שצריכים יציבות, אוטומציה, שליטה טובה יותר על סביבת הייצור ובסיס נכון לצמיחה."
                />
                <meta
                    name="keywords"
                    content="DevOps, תשתיות, ניטור, ענן, אוטומציה, פריסות, cloud operations, ניהול תשתיות"
                />
                <meta property="og:title" content="EpicFinal - דבאופס (DevOps)" />
                <meta
                    property="og:description"
                    content="ייצוב תשתיות, שיפור תהליכי פריסה, ניטור, אוטומציה וניהול ענן לעסקים שצריכים יותר שליטה ואמינות."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/operations" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - דבאופס (DevOps)" />
                <meta
                    name="twitter:description"
                    content="DevOps לעסקים שצריכים יציבות, שליטה ותשתית שאפשר לסמוך עליה."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"דבאופס (DevOps)"} />
            <div className="page-content">
                <Ops1 />
                <ConsultingForm
                    language="he"
                    formId="epic-operations-form"
                    conversionSendTo="AW-11461100984/GhHfCOXcrZgcELiLitkq"
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו מה קורה בתשתית שלכם"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לסביבת ה-DevOps שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    )
}

export default OperationsHePage

